import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';

/**
 * Same structure as sportiq-licence: each space only admits its own account type,
 * and a logged-in user who lands on the wrong space is sent to their own home
 * rather than being bounced to the login form.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      const url = state.url;
      const isClubHome = url.startsWith('/club');
      const isFedHome = url.startsWith('/federation');

      if (isClubHome && this.authService.isClub()) {
        return true;
      }
      if (isFedHome && this.authService.isFederation()) {
        return true;
      }

      // Logged in but on the wrong space — send them to their own home.
      // Never redirect to the URL that is already being guarded, or the router
      // cancels the navigation and the user appears stuck on the current page.
      if (this.authService.isClub() && !isClubHome) {
        this.router.navigate(['/club']);
        return false;
      }
      if (this.authService.isFederation() && !isFedHome) {
        this.router.navigate(['/federation']);
        return false;
      }

      // Authenticated but the account type matches no space — nothing to show.
      this.router.navigate(['/unauthorized']);
      return false;
    }

    // Not authenticated — back to the platform selector
    this.router.navigate(['/accueil']);
    return false;
  }
}
